// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EmailRegistrationPage-cls1__a9b38587145f2f1cbcec{/*!*/}.EmailRegistrationPage-cls2___f85de429af5afa5f773{display:flex;flex-direction:row;grid-gap:24px;gap:24px;width:100%}.EmailRegistrationPage-cls2___f85de429af5afa5f773>*{flex:1 1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "EmailRegistrationPage-cls1__a9b38587145f2f1cbcec",
	"cls2": "EmailRegistrationPage-cls2___f85de429af5afa5f773 EmailRegistrationPage-cls1__a9b38587145f2f1cbcec"
};
export default ___CSS_LOADER_EXPORT___;
